<div class="input-alert">
  <fa-icon [icon]="faExclamationCircle" class="input-alert__icon"></fa-icon>
  <span class="input-alert__text">{{ title }}</span>
</div>
